import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import logoPic from '../../assets/designSystem/logo/symbol-default.svg';
import KitoMenuIcon from './MenuIcon';
// import KitoToggle from '../Inputs/Toggle';
import VersionToggle from './VersionToggle';
import KitoSidebar from '../DataDisplay/Sidebar';
import arrow from '../../assets/designSystem/icons/simple-arrow.svg';
import './nav.css';
import SelectLanguage from '../Settings/Language';
// import ThemeContext from '../../context/ThemeContext';

function Nav({ label, sidebar, versionRoute, onVersionChange, logo = true, goBack }) {
  const [open, setOpen] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  // const { theme, toggleTheme } = useContext(ThemeContext);

  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const shouldShowVersionToggle = Boolean(versionRoute || onVersionChange);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowLanguageModal(false);
  };

  const sidebarContent = [
    { id: 1, key: 'sidebar.language', onClick: () => setShowLanguageModal(true) },
    { id: 2, key: 'sidebar.termsConditions', onClick: () => navigate('/terms') },
    { id: 3, key: 'sidebar.privacyPolicy', onClick: () => navigate('/policy') },
    { id: 4, key: 'sidebar.website', onClick: () => window.open('https://kitohealth.org', '_blank') },
    { id: 6, key: 'sidebar.managePermissions', onClick: () => navigate('/permissions') },
    { id: 7, key: 'sidebar.spinWheel', onClick: () => navigate('/spin-wheel') },
  ];

  return (
    <nav className="kito-nav">
      <div className="kito-nav__left">
        {goBack && (
          <button type="button" className="kito-nav__backBtn" onClick={() => navigate(-1)}>
            <img src={arrow} alt={t('navigation.backArrowAlt')} className="kito-nav__backBtn__arrow" rotate={-90} />
          </button>
        )}
        {logo && <img src={logoPic} alt="logo" className="kito-nav__logo" />}
      </div>
      <span>{label}</span>
      <div className="kito-nav__controls">
        {shouldShowVersionToggle && <VersionToggle route={versionRoute} onVersionChange={onVersionChange} />}
        {sidebar && (
          <>
            <KitoMenuIcon onClick={() => setOpen(!open)} active={open} />
            <KitoSidebar open={open}>
              <div className="kito-nav__sidebar">
                {/* <KitoToggle
                  variant="slider"
                  id="theme"
                  onChange={toggleTheme}
                  checked={theme === 'dark'}
                  suffix={theme === 'dark' ? t('versionToggle.dark') : t('versionToggle.light')}
                /> */}
                {sidebarContent.map((item) => (
                  <button type="button" key={item.id} className="kito-nav__sidebar__option" onClick={item.onClick}>
                    <p>{t(item.key)}</p>
                    <img src={arrow} alt="arrow" className="kito-nav__sidebar__option__arrow" />
                  </button>
                ))}
              </div>
            </KitoSidebar>
          </>
        )}
      </div>
      {showLanguageModal && <SelectLanguage changeLanguage={changeLanguage} />}
    </nav>
  );
}

Nav.propTypes = {
  label: PropTypes.string.isRequired,
  logo: PropTypes.bool,
  sidebar: PropTypes.bool,
  versionRoute: PropTypes.string,
  onVersionChange: PropTypes.func,
  goBack: PropTypes.bool,
};

Nav.defaultProps = {
  sidebar: false,
  logo: true,
  versionRoute: '/homepage',
  onVersionChange: () => {},
  goBack: false,
};

export default Nav;
